<template>
    <!-- 对话框 -->
    <el-dialog title="查看公告详情" :visible.sync="show" :with-header="false" :before-close="closeDialog" width="90%">
        <template>
            <div class="el-dialog-div">
                <div class="details">
                    <div class="title-detail">
                        <div class="title-square"></div>
                        <span class="span-title">通知名称：</span>
                    </div>
                    <span class="span-title1">{{ title }}</span>
                </div>

                <div class="details">
                    <div class="title-detail">
                        <div class="title-square"></div>
                        <span class="span-title">通知时间：</span>
                    </div>
                    <span class="span-title1">{{ time_stamp }}</span>
                </div>

                <div class="details-content">
                    <div class="title-detail">
                        <div class="title-square"></div>
                        <span class="span-title">通知详情：</span>
                    </div>
                    <span v-html="content" class="span-span-content"></span>
                </div>
                
               
            </div>
        </template>
    </el-dialog>
</template>

<script>
var _this;
export default {
    props: {
        isShow: Boolean,
        data: ''
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;
            _this.notice_id = _this.data;
            console.log(_this.notice_id, '_this.notice_id');
            _this.getAdminNoticeDetail();
        }
    },
    data() {
        return {
            show: false,

            // 表单数据

            notice_id: '',
            title: '',
            content: '',
            time_stamp: ''
        };
    },
    created() {
        _this = this;
    },
    methods: {
        getAdminNoticeDetail() {
            _this
                .$post('/notice/getAdminNoticeDetail', {
                    notice_id: _this.notice_id
                })
                .then((res) => {
                    _this.title = res.data.title;
                    _this.content = res.data.content;
                    _this.time_stamp = res.data.time_stamp;
                })
                .catch((err) => {});
        },

        // 关闭方法
        closeDialog() {
            _this.show = false;

            _this.notice_id = '';
            _this.title = '';
            _this.content = '';
            _this.time_stamp = '';
            _this.$emit('onSubmit');
        }
    }
};
</script>

<style scoped>
.el-dialog-div {
    height: 60vh;
    overflow-x: auto;
}
.title-detail {
    display: flex;
    align-items: center;
}
.details {
    display: flex;
    padding: 10px;
    align-items: center;
}


.span-title {
    display: inline-block;
    font-weight: 700;
    width: 100px;
}
.span-content {
    display: inline-block;
}
.details-content {
    display: flex;
    padding: 10px;
    align-items: start;
}

.title-square {
    background-color: #409eff;
    display: inline-block;
    width: 10px;
    height: 30px;
    margin-right: 5px;
}


.form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

.el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
}

.avatar-uploader {
    width: 100px;
    height: 100px;
}
.item-wrap {
    margin-bottom: 10px;
}
</style>
